export type MovieType = "movie" | "tv" | "variety";

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  rating: number;
  views: number;
  genres: string[];
  tags: string[];
  poster: string;
  backdrop: string;
  summary: string;
  director: string;
  cast: string[];
  duration: string;
  episodes?: string[];
  updatedAt: string;
  featured?: boolean;
}

export const TYPE_LABELS: Record<MovieType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};